(function () {
  function init(scope) {
    scope.querySelectorAll('[data-svemob-finder]').forEach(function (form) {
      if (form.dataset.ready) return; form.dataset.ready = 'true';
      var brand = form.querySelector('[data-finder-brand]'), model = form.querySelector('[data-finder-model]');
      var part = form.querySelector('[data-finder-part]'), query = form.querySelector('[data-finder-query]');
      var data = window.SVEMOB_CATALOG || {};
      function key() { return brand.value === 'iPhone' ? 'Apple' : brand.value; }
      function option(target, label, value) { var o = document.createElement('option'); o.textContent = label; o.value = value; target.append(o); }
      function updateParts() {
        part.replaceChildren(); option(part, 'Alla delar', '');
        var group = data[key()] || {models:[]};
        var chosen = group.models.find(function (m) { return m.name === model.value; });
        Object.keys(chosen ? chosen.types : group.types || {}).forEach(function (t) { option(part, t, t); });
        part.required = false; part.disabled = !model.value;
      }
      function updateModels() {
        model.replaceChildren(); option(model, 'Välj modell', '');
        var group = data[key()] || {models:[]};
        group.models.forEach(function (m) { option(model, m.name, m.name); });
        if (key() === 'Vidvie') { option(model, 'Alla Vidvie-produkter', 'Vidvie'); model.value = 'Vidvie'; }
        model.disabled = !brand.value; updateParts();
      }
      brand.addEventListener('change', updateModels); model.addEventListener('change', updateParts);
      form.addEventListener('submit', function (e) {
        if (!brand.value || !model.value) { e.preventDefault(); form.reportValidity(); return; }
        query.value = window.svemobCatalogQuery(key(), key() === 'Vidvie' ? null : model.value, part.value);
        try { sessionStorage.setItem('svemobSearchLabel', [model.value, part.value].filter(Boolean).join(' ')); } catch (_) {}
      });
      updateModels();
    });
  }
  init(document); document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
